export const QRCODE_STATIC_TYPE = {
  URL: 'URL',
  TEXT: 'TEXT',
  WIFI: 'WIFI',
  EMAIL: 'EMAIL',
  VCARD: 'VCARD',
  SMS: 'SMS',
  WHATS_APP: 'WHATSAPP',
};

export const QRCODE_DYNAMIC_MICROSITE_TYPE = {
  WEBSITE: 'website',
  PDF: 'pdf',
  LINKS: 'links',
  APP: 'app',
  IMAGES: 'images',
  VCARD_PLUS: 'vcard-plus',
  SOCIAL_MEDIA: 'social-media',
  COUPON: 'coupon',
  VIDEO: 'video',
} as const;

export const QRCODE_STATIC_NAME_PATH = {
  [QRCODE_STATIC_TYPE.URL]: 'createQrStep1:items:c1:name',
  [QRCODE_STATIC_TYPE.TEXT]: 'createQrStep1:items:c2:name',
  [QRCODE_STATIC_TYPE.WIFI]: 'createQrStep1:items:c3:name',
  [QRCODE_STATIC_TYPE.EMAIL]: 'createQrStep1:items:c4:name',
  [QRCODE_STATIC_TYPE.VCARD]: 'createQrStep1:items:c5:name',
  [QRCODE_STATIC_TYPE.SMS]: 'createQrStep1:items:c6:name',
  [QRCODE_STATIC_TYPE.WHATS_APP]: 'createQrStep1:items:c7:name',
};

export const QRCODE_DYNAMIC_NAME_PATH = {
  [QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA]: 'createQrStep1:items:b7:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS]: 'createQrStep1:items:b6:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.APP]: 'createQrStep1:items:b4:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES]: 'createQrStep1:items:b5:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS]: 'createQrStep1:items:b3:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.PDF]: 'createQrStep1:items:b2:name',
  [QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE]: 'createQrStep1:items:b1:name',
};

export const QRCODE_STATUS = {
  DONE: 'DONE',
  DRAFT: 'DRAFT',
} as const;

export const QRCODE_STATIC_STEP = {
  TYPE: 'type',
  CONTENT: 'content',
  STYLES: 'style',
};

export const QR_CODE_TYPE = {
  DYNAMIC: 'DYNAMIC',
  STATIC: 'STATIC',
};

export const QR_CODE_ID_PARAM_NAME = 'qrCodeId';
export const QR_CODE_TEMPLATE_PARAM_NAME = 'template';
export const COUPON_QR_ID_PARAM_NAME = 'couponQrId';
export const VIDEO_QR_ID_PARAM_NAME = 'videoQrId';
export const QR_CODE_FORM_NAME = 'qrCodeName';
export const QR_CODE_FOLDER_FORM_NAME = 'qrCodeFolder';
export const QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME = 'isEdit';
export const QR_CODE_BUILDER_CREATED_ID_PARAM_NAME = 'created_id';

export const QR_CODE_ERROR_CORRECTION_LEVELS = {
  L: 'L',
  M: 'M',
  Q: 'Q',
  H: 'H',
} as const;

export const QR_CODE_GRADIENT_TYPES = {
  vertical: 'vertical-gradiant',
  radial: 'radial-gradiant',
  square: 'square-gradiant',
  horizontal: 'horizontal-gradiant',
} as const;

export const LOCATION_VISIBILITIES = {
  HIDE_ADDRESS_LINK: 'HIDE_ADDRESS_LINK',
  SHOW_ADDRESS_LINK: 'SHOW_ADDRESS_LINK',
  SHOW_MAP: 'SHOW_MAP',
} as const;
